const counties = [
  'Buckinghamshire',
  'Cambridgeshire',
  'Cumbria',
  'Derbyshire',
  'Devon',
  'Dorset',
  'East Sussex',
  'Essex',
  'Gloucestershire',
  'Hampshire',
  'Hertfordshire',
  'Kent',
  'Lancashire',
  'Leicestershire',
  'Lincolnshire',
  'Norfolk',
  'North Yorkshire',
  'Northamptonshire',
  'Nottinghamshire',
  'Oxfordshire',
  'Somerset',
  'Staffordshire',
  'Suffolk',
  'Surrey',
  'Warwickshire',
  'West Sussex',
  'Worcestershire',
  'London, City of',
  'Barking and Dagenham',
  'Barnet',
  'Bexley',
  'Brent',
  'Bromley',
  'Camden',
  'Croydon',
  'Ealing',
  'Enfield',
  'Greenwich',
  'Hackney',
  'Hammersmith and Fulham',
  'Haringey',
  'Harrow',
  'Havering',
  'Hillingdon',
  'Hounslow',
  'Islington',
  'Kensington and Chelsea',
  'Kingston upon Thames',
  'Lambeth',
  'Lewisham',
  'Merton',
  'Newham',
  'Redbridge',
  'Richmond upon Thames',
  'Southwark',
  'Sutton',
  'Tower Hamlets',
  'Waltham Forest',
  'Wandsworth',
  'Westminster',
  'Barnsley',
  'Birmingham',
  'Bolton',
  'Bradford',
  'Bury',
  'Calderdale',
  'Coventry',
  'Doncaster',
  'Dudley',
  'Gateshead',
  'Kirklees',
  'Knowsley',
  'Leeds',
  'Liverpool',
  'Manchester',
  'Newcastle upon Tyne',
  'North Tyneside',
  'Oldham',
  'Rochdale',
  'Rotherham',
  'St. Helens',
  'Salford',
  'Sandwell',
  'Sefton',
  'Sheffield',
  'Solihull',
  'South Tyneside',
  'Stockport',
  'Sunderland',
  'Tameside',
  'Trafford',
  'Wakefield',
  'Walsall',
  'Wigan',
  'Wirral',
  'Wolverhampton',
  'Bath and North East Somerset',
  'Bedford',
  'Blackburn with Darwen',
  'Blackpool',
  'Bournemouth, Christchurch and Poole',
  'Bracknell Forest',
  'Brighton and Hove',
  'Bristol, City of',
  'Central Bedfordshire',
  'Cheshire East',
  'Cheshire West and Chester',
  'Cornwall',
  'Darlington',
  'Derby',
  'Durham, County',
  'East Riding of Yorkshire',
  'Halton',
  'Hartlepool',
  'Herefordshire',
  'Isle of Wight',
  'Isles of Scilly',
  'Kingston upon Hull',
  'Leicester',
  'Luton',
  'Medway',
  'Middlesbrough',
  'Milton Keynes',
  'North East Lincolnshire',
  'North Lincolnshire',
  'North Somerset',
  'Northumberland',
  'Nottingham',
  'Peterborough',
  'Plymouth',
  'Portsmouth',
  'Reading',
  'Redcar and Cleveland',
  'Rutland',
  'Shropshire',
  'Slough',
  'South Gloucestershire',
  'Southampton',
  'Southend-on-Sea',
  'Stockton-on-Tees',
  'Stoke-on-Trent',
  'Swindon',
  'Telford and Wrekin',
  'Thurrock',
  'Torbay',
  'Warrington',
  'West Berkshire',
  'Wiltshire',
  'Windsor and Maidenhead',
  'Wokingham',
  'York',
  'Antrim and Newtownabbey',
  'Ards and North Down',
  'Armagh City, Banbridge and Craigavon',
  'Belfast City',
  'Causeway Coast and Glens',
  'Derry and Strabane',
  'Fermanagh and Omagh',
  'Lisburn and Castlereagh',
  'Mid and East Antrim',
  'Mid-Ulster',
  'Newry, Mourne and Down',
  'Aberdeen City',
  'Aberdeenshire',
  'Angus',
  'Argyll and Bute',
  'Clackmannanshire',
  'Dumfries and Galloway',
  'Dundee City',
  'East Ayrshire',
  'East Dunbartonshire',
  'East Lothian',
  'East Renfrewshire',
  'Edinburgh, City of',
  'Eilean Siar',
  'Falkirk',
  'Fife',
  'Glasgow City',
  'Highland',
  'Inverclyde',
  'Midlothian',
  'Moray',
  'North Ayrshire',
  'North Lanarkshire',
  'Orkney Islands',
  'Perth and Kinross',
  'Renfrewshire',
  'Scottish Borders',
  'Shetland Islands',
  'South Ayrshire',
  'South Lanarkshire',
  'Stirling',
  'West Dunbartonshire',
  'West Lothian',
  'Blaenau Gwent',
  'Bridgend (Pen-y-bont ar Ogwr)',
  'Caerphilly (Caerffili)',
  'Cardiff (Caerdydd)',
  'Carmarthenshire (Sir Gaerfyrddin)',
  'Ceredigion (Sir Ceredigion)',
  'Conwy',
  'Denbighshire (Sir Ddinbych)',
  'Flintshire (Sir y Fflint)',
  'Gwynedd',
  'Isle of Anglesey (Sir Ynys Môn)',
  'Merthyr Tydfil (Merthyr Tudful)',
  'Monmouthshire (Sir Fynwy)',
  'Neath Port Talbot (Castell-nedd Port Talbot)',
  'Newport (Casnewydd)',
  'Pembrokeshire (Sir Benfro)',
  'Powys',
  'Rhondda Cynon Taff (Rhondda CynonTaf)',
  'Swansea (Abertawe)',
  'Torfaen (Tor-faen)',
  'Vale of Glamorgan, The (Bro Morgannwg)',
  'Wrexham (Wrecsam)',
];

export default counties;
